import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';
import BranchesTable from './BranchesTable';
import BranchCreateNewBranchModal from './BranchesCreateNewBranchModal';
import BranchesPaginator from './BranchesPaginator';
import BranchesSearchAndFilterBar from './BranchesSearchAndFilterBar';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_branches.module.scss';
import BranchesDetailsModal from './BranchesDetailsModal';
import BranchesDeleteBranchModal from './BranchesDeleteBranchModal';

const Branches = () => {
    const dispatch = useAppDispatch();

    const handleCreateNewBranchClick = () => dispatch(combinedActions.branchSetCreateNewBranchModalIsOpen(true));

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Branches List'
                    className={Styles.title}
                    size='l'
                    isBold
                />

                {createAccessModules.find(module => module === ModuleEnum.BranchManagement)
                    && (
                        <ActionButton
                            label='+ Create New Branch'
                            onClick={handleCreateNewBranchClick}
                        />
                    )
                }
            </TabPageHeaderWrapper>

            <BranchesSearchAndFilterBar />

            <BranchesTable />

            <BranchesPaginator />

            <BranchCreateNewBranchModal />

            <BranchesDetailsModal />

            <BranchesDeleteBranchModal />
        </TabPageContainer>
    );
};

export default Branches;
